import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSite } from "../context/SiteContext";
import { mediaUrl, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { settings } = useSite();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative px-4" style={{ background: "radial-gradient(ellipse at top, #2a0507 0%, #141414 55%)" }}>
      <div className="w-full max-w-md bg-black/70 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl animate-fade-up">
        <Link to="/" className="flex justify-center mb-6">
          <img src={mediaUrl(settings.logo_url) || "/logo.png"} alt="logo" className="h-12" />
        </Link>
        <h1 className="text-3xl font-black text-white text-center">Tekrar Hoş Geldin</h1>
        <p className="text-center text-gray-400 text-sm mt-1 mb-6">Odalara katılmak için giriş yap</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Şifre"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          {error && <p data-testid="login-error" className="text-sm text-red-500">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full bg-[#E50914] hover:bg-[#F40612] text-white font-semibold py-3 rounded-md transition-all active:scale-95 disabled:opacity-60">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <p className="text-center text-sm text-gray-400 mt-6">
          Hesabın yok mu? <Link to="/register" data-testid="go-register" className="text-white font-medium hover:underline">Kayıt Ol</Link>
        </p>
      </div>
    </div>
  );
}
